import React from "react";
import type { FieldProps } from "./types";

export type FieldMap<P extends {} = {}> = Record<
  string,
  React.ComponentType<P>
>;
type DynamicFieldsContextType<P extends {} = {}> = {
  fieldMap?: FieldMap<P>;
  lazyFieldMap?: FieldMap<P>;
};

export function createDynamicFieldsContext<P extends {}>(): React.Context<
  DynamicFieldsContextType<P>
> {
  return React.createContext({} as DynamicFieldsContextType<P>);
}
export const DynamicFieldsContext = createDynamicFieldsContext<FieldProps>();
